<div *ngIf="enableLoader" class="preloader"></div>